import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  radioValidator,
  textareaValidatorRequired,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.DAMAGES_ADDITIONAL]: yup.object({
    [ComponentId.ARE_PREVIOUS_DAMAGE_PRESENT]: radioValidator,
    [ComponentId.PREVIOUS_DAMAGE_DESCRIPTION]:
      trimmedString.onlyIfFieldIsVisible(textareaValidatorRequired(100)),
    [ComponentId.ARE_OTHER_DAMAGES_PRESENT]: radioValidator,
    [ComponentId.OTHER_DAMAGES_DESCRIPTION]: trimmedString.onlyIfFieldIsVisible(
      textareaValidatorRequired(100)
    ),
    [ComponentId.PROPERTY_PLACE]: trimmedString.onlyIfFieldIsVisible(
      textareaValidatorRequired(500)
    ),
  }),
};
